<!--div class="cursor" (click)="attachmentUpload()"><span>Upload</span></div-->
<p-toast position="top-center" class="custom-toast"></p-toast>
<div align="center" *ngIf="!roPaymentUpload" class="upload-area" [ngClass]="{'hide': (pageAccess == 'audit-workflow' || pageAccess == 'workorder' || pageAccess == 'damaged-vehicle') && action == 'uploading', 'video-library-area': pageAccess == 'video-library'}">
    <div class="custom-upload cursor hide">
        <div class="custom-upload-area" (click)="mediaUpload()">{{chooseLable}}</div>
    </div>
    <div class="upload-col attachment-file common-attachment-file media-attachment-file files cursor">
        <p-fileUpload [accept]="acceptArray" #uploader name="upload[]" customUpload="true"
            [chooseLabel]="chooseLable" [chooseIcon]="chooseIcon"
            [showUploadButton]="showUpload" [showCancelButton]="showCancel"
            (onSelect)="onUpload($event)"
            [multiple]="multipleSelect">
            <ng-template pTemplate="content">
                <p class="content-message placeholder text-center">Drag & Drop Files Here</p>
            </ng-template>
        </p-fileUpload>
        <!--div role="alert" class="p-messages p-component">
            <div class="ng-trigger ng-trigger-messageAnimation p-message p-message-error" *ngFor="let err of customError; let i=index">
                <div class="p-message-wrapper">
                    <span class="p-message-icon pi pi-times-circle"></span>
                    <span class="p-message-summary">{{err.fileName}}: <span class="warning">{{invalidFileText}}</span></span><span *ngIf="err.maxSize != '-1'" class="p-message-detail">, {{maxUploadText}} {{err.maxSize}}.</span>
                    <button type="button" class="p-message-close" (click)="removeMessage(i)"><i class="p-message-close-icon pi pi-times"></i></button>
                </div>
            </div>
        </div-->
    </div>
    <div class="upload-col link common-link media-link cursor" [ngClass]="{'disable': !addLinkFlag || !addLinkBool,'pointer-none':!addLinkBool, 'hide': pageAccess == 'welcome-message'}" (click)="addLink()">
        <img src="{{mediaManagerPath}}/{{linkIcon}}"
             srcset="{{mediaManagerPath}}/link-icon@2x.png 2x, {{mediaManagerPath}}/link-icon@3x.png 3x">
        Add Link
    </div>
    <div *ngIf="!apiUrl.attachmentNewPOPUP && !apiUrl.isPublicFormPage" class="upload-col cloud cursor" [ngClass]="{'cloud-hidden': tvsDomain , 'hide': pageAccess == 'welcome-message'}" (click)="mediaUpload()">
        <img src="{{mediaManagerPath}}/{{mediaIcon}}">
        From Cloud
    </div>
    <div *ngIf="!instantUpload && apiUrl.attachmentNewPOPUP && !apiUrl.isPublicFormPage" class="upload-col cloud cursor" [ngClass]="{'cloud-hidden': tvsDomain , 'hide': pageAccess == 'welcome-message'}" (click)="tapOnMediaUpload()">
        <img src="{{mediaManagerPath}}/{{mediaIcon}}">
        From Cloud
    </div>
</div>

<!-- {{gtsApi.fileDatasPrev?.length }} || {{gtsApi.fileDatas?.items}} | {{isUpoladButtonShow}} -->
<div class="cursor" style="display: flex; justify-content: flex-end;"
    *ngIf="gtsApi.fileDatas.items?.length > 0" (click)="gtsRuntimeUpload()">
    <div class="uploadButton">
        <img src="assets/images/upload-icon.png" style="width: 14px; margin-right: 10px;" /> Upload Attachment
    </div>
</div>

<div role="alert" class="p-messages p-error-messages p-component">
    <div class="ng-trigger ng-trigger-messageAnimation p-message p-message-error" *ngFor="let err of customError; let i=index">
        <div class="p-message-wrapper">
            <span class="p-message-icon pi pi-times-circle"></span>
            <span class="p-message-summary">{{err.fileName}}: <span class="warning">{{invalidFileText}}</span></span><span *ngIf="err.maxSize != '-1'" class="p-message-detail">, {{maxUploadText}} {{err.maxSize}}.</span>
            <button type="button" class="p-message-close" (click)="removeMessage(i)"><i class="p-message-close-icon pi pi-times"></i></button>
        </div>
    </div>
</div>

<div class="reference-info" *ngIf="attachments.length == 0 && !checkingMedia && loadingUploadImageInit">
    <div class="loading cust-loader file-loader attachment-loader">
        <img src="assets/images/common/attachment-loader.png" alt="Loader" />
    </div>
</div>

<div class="reference-info" *ngIf="attachments.length >= 0" [ngClass]="{ 'ro-payment-upload-reference-info' : pageAccess == 'ro-payment-upload', 'empty mr-0': attachments.length == 0, 'load-media': attachments.length == 0 && checkingMedia, 'from-media': fromMedia, 'hide': pageAccess == 'audit-workflow' && action == 'uploading'}">
    <div *ngIf="checkingMedia && !roPaymentUpload && !loadingUploadImageInit" class="loading cust-loader file-loader attachment-loader">
        <img src="assets/images/common/attachment-loader.png" alt="Loader" />
    </div>
    <!-- Attachment List-->
    <app-attachment-view *ngIf="!attachmentView && attachments.length > 0" [paymentMethodEnabledFlag]="roPaymentUpload" [loading]="fileLoading" [action]="action" [access]="pageAccess" [files]="uploadedFiles" [attachments]="attachments" (attachmentAction)="attachmentAction($event)"></app-attachment-view>
    <app-attachment-view *ngIf="attachmentView && attachments.length > 0" [paymentMethodEnabledFlag]="roPaymentUpload" [loading]="fileLoading" [action]="action" [access]="pageAccess" [files]="uploadedFiles" [attachments]="attachments" (attachmentAction)="attachmentAction($event)"></app-attachment-view>
</div>

<div *ngIf="roPaymentUpload && ((attachments.length == 0 && attachmentItems.length == 0 ) || (attachments.length == 0 && attachmentItems.length == 1 ) || (attachments.length == 1 && attachmentItems.length == 0 ))" title="Check" class="attach-card-sec cursor">
    <span class="mt-2" style="position: relative;width: 21px;height: 21px;display: block;">
        <img src="assets/images/common/pay-edit-icon.png" alt="Loader"
         style="position: absolute;bottom: 0;top: 60px;left: 165px;" />
    </span>

    <p-fileUpload #uploader name="upload[]" customUpload="true"
        [chooseLabel]="chooseLable" [chooseIcon]="chooseIcon"
        [showUploadButton]="showUpload" [showCancelButton]="showCancel"
        (onSelect)="onUpload($event)"
        multiple="multiple">
    </p-fileUpload>

</div>

<div class="attachment-progress refer-info upload-info attachment-info">
    <p-dialog *ngIf="attachmentProgress" class="attachment-uploading" header="{{successMsg}}" [(visible)]="attachmentProgress" [(closeOnEscape)]="closeDialog" [(modal)]="attachmentProgress" [modal]="true"  [baseZIndex]="10000" [draggable]="false" [resizable]="false">
        <div class="attachment-cont">
            <div class="upload-items attachment-row {{file.type}}" [ngClass]="{'hide': file.accessType == 'media'}" *ngFor="let file of attachments; let i = index;">
                <div *ngIf="file.flagId == 1 || ( file.flagId == 3 && !mediaConvertFlag ) || file.flagId == 4 || file.flagId == 5 || file.flagId == 7" class="{{file.type}}">
                    <div class="attachment-col bg-col" [ngClass]="{ 'doc-bg' : ( file.flagId == 3 && !mediaConvertFlag ) || file.flagId == 4 || file.flagId == 5 }" [ngStyle]="{'background-image': 'url(' + file.thumbFilePath + ')'}"></div>
                    <div class="attachment-col cont-col">
                        <div class="caption" [ngClass]="{'active': file.progress > 100}">
                            <span *ngIf="!file.audioDesc">{{file.originalFileName}}</span>
                            <span *ngIf="file.audioDesc">{{file.audioCaption}}</span>
                            <span *ngIf="file.progress == 0" class="cursor cancel" (click)="cancelUpload(i)"></span>
                        </div>
                        <p-progressBar *ngIf="file.progress <= 100" class="media-bar" mode="determinate" [showValue]="false" [value]="file.progress"></p-progressBar>
                        <div class="progress" [ngClass]="{'adas-progress': pageAccess == 'adasCalproReport'}" *ngIf="file.progress <= 100">
                            <span class="progress-col info">{{file.progress}}%</span>
                            <span class="progress-col size text-right">{{file.fileSize}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="file.flagId == 2" class="{{file.type}}">
                    <div class="attachment-col bg-col">
                        <video  class="fillWidth" [src]="file.videoFilePath_att" width="90" height="90" controls preload="none">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div class="attachment-col cont-col">
                        <div class="caption" [ngClass]="{'active': file.progress > 100 && !file.processFlag}">
                            <span title="{{file.originalFileName}}">{{file.originalFileName}}</span>
                            <span *ngIf="file.processFlag" class="media-process">{{processingTxt}}</span>
                            <span *ngIf="file.progress == 0" class="cursor cancel" (click)="cancelUpload(i)"></span>
                        </div>
                        <p-progressBar *ngIf="file.progress <= 100" class="media-bar" mode="determinate" [showValue]="false" [value]="file.progress"></p-progressBar>
                        <div class="progress" *ngIf="file.progress <= 100">
                            <span class="progress-col info">{{file.progress}}%</span>
                            <span class="progress-col size text-right">{{file.fileSize}}</span>
                        </div>
                    </div>
                    <div class="video-thumb-container">                        
                        <div *ngIf="file.videoThumbnails || file.videoThumbLoading" style="color: #9b9a9a;padding-left: 0;padding-bottom: 0;padding-top: 10px;">
                            Select a thumbnail for your video.
                        </div>
                        <div *ngIf="file.videoThumbLoading" class="trst" align="center" style="height:200px ;">
                            <img src="assets/images/landing-page/loading-more.svg" alt="Loader" />
                        </div>
                        <div *ngIf="file.videoThumbnails && !file.videoThumbLoading" class="thumbnail-container mb-4">
                            <img class="cursor-pointer" [ngClass]="{ 'selectedThumb': file.selectedThumbnailIndex == j}" *ngFor="let thumb of file.videoThumbnails; index as j" [src]="thumb?.img" alt="" srcset="" (click)="selectThumbnail(j,i)" >
                        </div>
                        <div *ngIf="file.videoThumbnails && !file.videoThumbLoading && file.fileThumbprocessFlag && file.fileThumbProgress > 0 ">
                            <div class="attachment-col bg-col" [ngStyle]="{'background-image': 'url(' + file.thumbFilePath + ')'}"></div>
                            <div class="attachment-col cont-col">
                                <div class="caption" [ngClass]="{'active': file.fileThumbProgress > 100 }">
                                    <span title="{{file.thumbFileName}}">{{file.thumbFileName}}</span>
                                    <!--span *ngIf="fileThumbProgress == 0" class="cursor cancel" (click)="cancelUpload(i)"></span-->
                                </div>
                                <p-progressBar *ngIf="file.fileThumbProgress <= 100" class="media-bar" mode="determinate" [showValue]="false" [value]="file.fileThumbProgress"></p-progressBar>
                                <div class="progress" *ngIf="file.fileThumbProgress <= 100">
                                    <span class="progress-col info">{{file.fileThumbProgress}}%</span>
                                    <span class="progress-col size text-right">{{file.thumbFileSize}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="file.flagId == 3 && mediaConvertFlag" class="{{file.type}}">
                    <div class="attachment-col bg-col doc-bg" [ngStyle]="{'background-image': 'url(' + file.thumbFilePath + ')'}"></div>
                    <div class="attachment-col cont-col">
                        <div class="caption" [ngClass]="{'active': file.progress > 100 && !file.processFlag}">
                            <span title="{{file.originalFileName}}">{{file.originalFileName}}</span>
                            <span *ngIf="file.processFlag" class="media-process">{{processingTxt}}</span>
                            <span *ngIf="file.progress == 0" class="cursor cancel" (click)="cancelUpload(i)"></span>
                        </div>
                        <p-progressBar *ngIf="file.progress <= 100" class="media-bar" mode="determinate" [showValue]="false" [value]="file.progress"></p-progressBar>
                        <div class="progress" *ngIf="file.progress <= 100">
                            <span class="progress-col info">{{file.progress}}%</span>
                            <span class="progress-col size text-right">{{file.fileSize}}</span>
                        </div>
                    </div>
                </div>                                
                <div *ngIf="file.flagId == 6" class="{{file.type}}">
                    <div class="attachment-col bg-col" [ngStyle]="{'background-image': 'url(' + file.thumbFilePath + ')'}"></div>
                    <div class="attachment-col cont-col">
                        <div class="caption" [ngClass]="{'active': file.progress > 100}">
                            <span>{{file.url}}</span>
                            <span *ngIf="file.progress == 0" class="cursor cancel" (click)="cancelUpload(i)"></span>
                        </div>
                        <p-progressBar *ngIf="file.progress < 100" class="media-bar" mode="determinate" [showValue]="false" [value]="file.progress"></p-progressBar>
                        <div class="progress" *ngIf="file.progress < 100">
                            <span class="progress-col info">{{file.progress}}%</span>
                            <span class="progress-col size text-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </p-dialog>
</div>